import { useRef, useState } from "react"
import "./styles/Backoffice.css"
import { Toaster, toast } from "react-hot-toast"
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { casosActions } from "../service";
import { RoundedDialog } from "./styles/RoundedDialog";
import { Box } from '@mui/material';

function CasosBack(props) {
    const formCasos = useRef()
    const updateCasoForm = useRef()
    const [openF, setOpenF] = useState(false)
    const [modal, setModal] = useState(false);
    const [caso, setCaso] = useState();

    const sendCasos = (e) => {
        e.preventDefault()
        formCasos.current.focus()
        let data = new FormData(formCasos.current)
        casosActions.save(data)
            .then(res => {
                res.success ? (
                    toast.success("Cargado correcatmente", {
                        style: {
                            backgroundClip: "#f09236",
                            color: "white",
                            fontWeight: "bold"
                        }
                    })
                ) : (
                    toast.error("Error al cargar los datos vuelve a intentar mas tarde", {
                        style: {
                            backgroundColor: "#f09236",
                            color: "white",
                            fontWeight: "bold"
                        }
                    })
                )
                res.success && formCasos.current.reset()
                let casosArray = props.casos
                casosArray.push(res.payload)
                props.setCasos(casosArray)
                setOpenF(!openF)
            })
    }

    function removeItem(id) {
        casosActions.removeCasos(id)
            .then(res => {
                toast.success("Eliminado correctamente", {
                    style: {
                        backgroundClip: "#f09236",
                        color: "white",
                        fontWeight: "bold"
                    }
                })
                props.setCasos(props.casos.filter(caso => caso._id !== id))
            })
    }
    const updateCaso = (e) => {
        e.preventDefault()
        updateCasoForm.current.focus()
        let data = new FormData(updateCasoForm.current)
        casosActions.update(data)
            .then(res => {
                res.success && toast.success("Actualizado correcatmente", {
                    style: {
                        backgroundClip: "#f09236",
                        color: "black",
                        fontWeight: "bold"
                    }
                })
                let casosArray = [...props.casos]
                let index = props.casos.map(n => n._id).indexOf(res.payload._id)
                casosArray.splice(index, 1, { ...res.payload })
                props.setCasos(casosArray)
                setModal(!modal)
            })
    }
    const handleClick = (caso) => {
        setCaso(caso)
        setModal(!modal)
    }
    return (
        <>
            <Toaster
                position="bottom-right" />
            <h2>CASOS</h2>
            <ul className="ulContainer">
                {props.casos?.map(caso => {
                    return (
                        <li key={caso._id}>
                            {caso.title.es}
                            <div>
                                <EditIcon onClick={() => handleClick(caso)} className="btnModify" />
                                <DeleteIcon className="btnModify" onClick={() => removeItem(caso._id)} />
                            </div>
                        </li>
                    )

                })}
            </ul>
            <button onClick={() => setOpenF(!openF)}>Cargar caso</button>
            <form ref={formCasos} onSubmit={(e) => sendCasos(e)} className={openF ? "formBack" : "formBack none"}>
                <button type="button" className="close" style={{ color: "black" }} onClick={() => setOpenF(!openF)}>+</button>
                <h2>Cargar casos</h2>

                <div className="fielsetContainer">

                    <fieldset style={{ flexDirection: "column", display: "flex" }}>
                        <legend>TÍTULO</legend>
                        <label htmlFor="titleES">Título en español</label>
                        <input required name="titleES" className="input" id="titleES" placeholder="Ttulo español" type="text" />
                        <label htmlFor="titleEN">Título en inglés</label>
                        <input required name="titleEN" className="input" id="titleEN" placeholder="Titulo inglés" type="text" />
                    </fieldset>
                    <fieldset style={{ flexDirection: "column", display: "flex" }}>
                        <legend>NECESIDAD</legend>
                        <label htmlFor="needES">Necisidad en español</label>
                        <textarea required name="needES" className="input" id="needES" placeholder="Necesidad español" type="text" />
                        <label htmlFor="needEN">Necisidad en inglés</label>
                        <textarea required name="needEN" className="input" id="needEN" placeholder="Necesidad inglés" type="text" />
                    </fieldset>
                </div>
                <div className="fielsetContainer">
                    {/* <fieldset style={{ flexDirection: "column", display: "flex" }}>
                        <legend>SOLUCIÓN</legend>
                        <label htmlFor="solutionES">Solución en español</label>
                        <textarea required name="solutionES" className="input" id="solutionES" placeholder="Solucion español" type="text" />
                        <label htmlFor="solutionEN">Solución en inglés</label>
                        <textarea required name="solutionEN" className="input" id="solutionEN" placeholder="Solucion inglés" type="text" />
                    </fieldset> */}
                    {/* <fieldset style={{ flexDirection: "column", display: "flex" }}> */}
                    <fieldset style={{ flexDirection: "column", display: "flex"}}>
                        <legend>Imagen</legend>
                        <label htmlFor="imageUrl">URL de imagen</label>
                        <input required name="imageUrl" className="input" id="imageUrl" placeholder="URL" type="text" />
                    </fieldset>
                    <fieldset style={{ flexDirection: "column", display: "flex" }}>
                        <legend>Link</legend>
                        <label htmlFor="imgUrl">URL de web</label>
                        <input name="link" className="input" id="link" placeholder="URL" type="text" />
                    </fieldset>
                </div>
                <button className="btnSend" type="submit">Cargar</button>
            </form>
            {modal && (
                <RoundedDialog
                    open={true}
                    fullWidth
                    maxWidth='lg'
                    style={{ border: '1px solid black', }}
                    className="modalEdit"
                >
                    <button type="button" className="close" style={{ color: "black" }} onClick={() => setModal(!modal)}>+</button>
                    <Box sx={{ padding: '0', backgroundColor: 'white', height: "100vh" }}>
                        <form ref={updateCasoForm} onSubmit={(e) => updateCaso(e)} className="formBack" >

                            <h2>Actualizar casos</h2>

                            <div className="fielsetContainer">

                                <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>TÍTULO</legend>
                                    <label htmlFor="titleES">Título en español</label>
                                    <input defaultValue={caso.title.es} required name="titleES" className="input" id="titleES" placeholder="Ttulo español" type="text" />
                                    <label htmlFor="titleEN">Título en inglés</label>
                                    <input defaultValue={caso.title.en} required name="titleEN" className="input" id="titleEN" placeholder="Titulo inglés" type="text" />
                                </fieldset>
                                <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>NECESIDAD</legend>
                                    <label htmlFor="needES">Necisidad en español</label>
                                    <textarea defaultValue={caso.need.es} required name="needES" className="input" id="needES" placeholder="Necesidad español" type="text" />
                                    <label htmlFor="needEN">Necisidad en inglés</label>
                                    <textarea defaultValue={caso.need.en} required name="needEN" className="input" id="needEN" placeholder="Necesidad inglés" type="text" />
                                </fieldset>
                            </div>
                            <div className="fielsetContainer">
                                {/* <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>SOLUCIÓN</legend>
                                    <label htmlFor="solutionES">Solución en español</label>
                                    <textarea defaultValue={caso.solution.es} required name="solutionES" className="input" id="solutionES" placeholder="Solucion español" type="text" />
                                    <label htmlFor="solutionEN">Solución en inglés</label>
                                    <textarea defaultValue={caso.solution.en} required name="solutionEN" className="input" id="solutionEN" placeholder="Solucion inglés" type="text" />
                                </fieldset> */}
                                {/* <fieldset style={{ flexDirection: "column", display: "flex" }}> */}
                                <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>Imagen</legend>
                                    <label htmlFor="imageUrl">URL de imagen</label>
                                    <input defaultValue={caso.imgUrl} required name="imageUrl" className="input" id="imageUrl" placeholder="URL" type="text" />
                                </fieldset>
                                <fieldset style={{ flexDirection: "column", display: "flex" }}>
                                    <legend>Link</legend>
                                    <label htmlFor="imgUrl">URL de web</label>
                                    <input defaultValue={caso.link} required name="link" className="input" id="link" placeholder="URL" type="text" />
                                </fieldset>
                            </div>
                            <input type="hidden" defaultValue={caso._id} name="id" id="id" />
                            <button className="btnSend" type="submit">Actualizar</button>
                        </form>
                    </Box>
                </RoundedDialog>
            )}
        </>
    )
}


export default CasosBack